module.exports = __webpack_public_path__ + "static/logo-73d67af2281217334a5631bf18d2af55.jpg";